import changeRoute from 'root/src/client/logic/route/actions/changeRoute';
export const clearRoute = () => (dispatch) => {
    dispatch(changeRoute({ routeId: undefined }));
};
